<template>
  <component
      :is="!!link ? 'a' : 'div'"
      :href="!!link ? link : false"
      :class="`_${type}`"
      :style="{ backgroundColor: bgColor }"
      :target="isLinkBlank ? '_blank' : '_self'"
      class="badge"
  >
    <img v-if="iconSrc" :src="iconSrc" :alt="title" class="badge__icon">
    <p
        :style="{ color: color }"
        :class="isSmall ? 'p3-medium' : 'p2-medium'"
        v-html="title"
    />
  </component>
</template>

<script>
export default {
  name: 'badge',
  props: {
    title: {
      type: String,
      required: true,
    },
    type: { // grey, green, orange, red, lightgreen, yellow, blue, white, black
      type: String,
      default: 'grey',
    },
    bgColor: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: ''
    },
    link: {
      type: String,
      default: ''
    },
    iconSrc: {
      type: String,
      default: ''
    },
    isSmall: {
      type: Boolean,
      default: false
    },
    isLinkBlank: {
      type: Boolean,
      default: false
    }
  }
};
</script>